import classNames from "classnames";
import {forwardRef} from "react";
import {Accordion as BSAccordion} from "react-bootstrap";

import {AccordionProps, AccordionVariant} from "@/components/accordion/Accordion.types.ts";
import {AccordionBody} from "@/components/accordion/subComponents/AccordionBody/AccordionBody.tsx";
import {AccordionHeader} from "@/components/accordion/subComponents/AccordionHeader/AccordionHeader.tsx";
import {AccordionItem} from "@/components/accordion/subComponents/AccordionItem/AccordionItem.tsx";
import {createStyleContext, StyleContextProviderFactory} from "@/components/context/StyleContext.tsx";

import styles from "./Accordion.module.scss";

export const AccordionStyleContext = createStyleContext<AccordionVariant>();
export const AccordionStyleContextProvider = StyleContextProviderFactory<AccordionVariant>(AccordionStyleContext);

// This component is an accordion component that expands and collapses sections of content.
// So far this is only being used with the NavBar
const AccordionComponent = forwardRef<HTMLDivElement, AccordionProps>(
  ({variant = "default", children, ...rest}, ref) => (
    <BSAccordion ref={ref} {...rest} className={classNames(styles[variant], rest.className)}>
      <AccordionStyleContextProvider style={{variant}}>{children}</AccordionStyleContextProvider>
    </BSAccordion>
  )
);

AccordionComponent.displayName = "Accordion";

export const Accordion = Object.assign(AccordionComponent, {
  Item: AccordionItem,
  Header: AccordionHeader,
  Body: AccordionBody,
});
